export default "__VITE_ASSET__B3C$_HgS__"